function order (apiConfig) {
  return {
    requestNewOrder (formData, successFunc, failFunc) {
      const route = '/v1/create-jobs'
      const rq = apiConfig.context.$http.post(
        route,
        formData,
        apiConfig.requestObj()
      )
      return apiConfig.buildPromise(rq, successFunc, failFunc)
    },
    // getJobUpdate (comboId, successFunc, failFunc) {
    //   const route = '/v1/job-update/' + comboId
    //   const rq = apiConfig.context.$http.get(route, apiConfig.requestObj())
    //   return apiConfig.buildPromise(rq, successFunc, failFunc)
    // },
    getOrderUpdate (comboId, successFunc, failFunc) {
      const route = '/v1/order-update/' + comboId
      const rq = apiConfig.context.$http.get(route, apiConfig.requestObj())
      return apiConfig.buildPromise(rq, successFunc, failFunc)
    },
    requestOrder (comboId) {
      const route = '/v1/request-order/' + comboId
      const rq = apiConfig.context.$http.get(route, apiConfig.requestObj())
      return apiConfig.buildPromise(rq)
    },
    // //note that this comboID is a different combo than for users
    // //it has the full token instead of a partial
    // approveJobOrder (comboId) {
    //   const route = '/v1/approve-job-order/' + comboId
    //   const rq = apiConfig.context.$http.get(route, apiConfig.requestObj())
    //   return apiConfig.buildPromise(rq)
    // },
  }
}
export default order
